export enum EFormFieldType {
    TEXT = 'text',
    TEXTAREA = 'textarea',
    DROPDOWN = 'dropdown',
    NUMBER = 'number',
    PRICE = 'price',
}